import { useState } from "react";
import { ChevronDown, Phone, Calendar, Filter } from "lucide-react";
import { useFilterContext } from "../../context/FilterContext";
import { nigerianNetworks } from "../../utils/helpers";

export default function Filters() {
  const {
    selectedNetwork,
    phoneNumber,
    startDate,
    endDate,
    company,
    setSelectedNetwork,
    setPhoneNumber,
    setStartDate,
    setEndDate,
    setCompany,
    handleFilter,
    handleReset,
  } = useFilterContext();

  const [isNetworkOpen, setIsNetworkOpen] = useState(false);

  return (
    <div className="w-full mx-auto p-6 bg-white border border-gray-200 rounded-lg">
      <div className="flex items-center gap-2 mb-6">
        <Filter className="w-5 h-5 text-gray-600" />
        <h2 className="text-lg font-medium text-gray-900">Filter Options</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Network Dropdown */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Network
          </label>
          <div className="relative">
            <button
              onClick={() => setIsNetworkOpen(!isNetworkOpen)}
              className="w-full px-3 py-2 text-left bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500 text-gray-900"
            >
              {selectedNetwork
                ? nigerianNetworks.find((n) => n.value === selectedNetwork)
                    ?.label
                : "Select network"}
              <ChevronDown
                className={`absolute right-3 top-2.5 w-4 h-4 text-gray-500 transition-transform ${
                  isNetworkOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {isNetworkOpen && (
              <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-sm max-h-48 overflow-auto">
                {nigerianNetworks.map((network) => (
                  <button
                    key={network.value}
                    onClick={() => {
                      setSelectedNetwork(network.value);
                      setIsNetworkOpen(false);
                    }}
                    className="w-full px-3 py-2 text-left hover:bg-gray-50 text-gray-900"
                  >
                    <div className="font-medium">{network.label}</div>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Phone Number Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Phone Number
          </label>
          <div className="relative">
            <Phone className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
            <input
              type="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="0803 123 4567"
              className="w-full pl-9 pr-3 py-2 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500 text-gray-900 placeholder:text-gray-400"
            />
          </div>
        </div>

        {/* Start Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            From
          </label>
          <div className="relative">
            <Calendar className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full pl-9 pr-3 py-2 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500 text-gray-900"
            />
          </div>
        </div>

        {/* End Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            To
          </label>
          <div className="relative">
            <Calendar className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full pl-9 pr-3 py-2 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500 text-gray-900"
            />
          </div>
        </div>

        {/* Company Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Company
          </label>
          <div className="relative">
            <input
              type="text"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              placeholder="Enter company name"
              className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500 text-gray-900 placeholder:text-gray-400"
            />
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-3 mt-6 pt-4 border-t border-gray-100">
        <button
          onClick={handleFilter}
          className="px-4 py-2 bg-gray-900 text-white rounded-md hover:bg-gray-800 transition-colors font-medium text-sm"
        >
          Apply Filters
        </button>
        <button
          onClick={handleReset}
          className="px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors font-medium text-sm"
        >
          Clear
        </button>
      </div>
    </div>
  );
}
